module.exports = __webpack_public_path__ + "img/classify-item5-active.528692d3.png";